import { render } from "./FTSWeeklyPeriodField.vue?vue&type=template&id=6dd4b920&ts=true"
import script from "./FTSWeeklyPeriodField.vue?vue&type=script&lang=ts"
export * from "./FTSWeeklyPeriodField.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__